/**
 * In-memory cache for SKU return-reason investigation.
 * Dropped whenever dashboard filters change — never persisted.
 */

export const skuReasonCacheKey = ({
  clientId,
  startDate,
  endDate,
  channels = [],
  sku,
} = {}) =>
  JSON.stringify({
    clientId: clientId || "",
    startDate: startDate || "",
    endDate: endDate || "",
    channels: [...(channels || [])].filter(Boolean).sort(),
    sku: sku || "",
  });

export class SkuReasonMemoryCache {
  constructor() {
    this.map = new Map();
  }

  get(key) {
    return this.map.get(key);
  }

  set(key, value) {
    this.map.set(key, value);
  }

  clear() {
    this.map.clear();
  }
}
